<template>
    <svg :title="`${capitalizedName}`" width="1em" height="1em" :class="getClasses()"><use :xlink:href="`${themeUrl}/dist/images/spritemap.svg?v=1#sprite-${name}`" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
</template>

<script>
    export default {
        name: 'Icon',
        props: ['name', 'color'],
        computed: {
            capitalizedName() {
                return this.name[0].toUpperCase() + this.name.slice(1);
            }
        },
        data() {
            return {
                themeUrl: window.theme_url
            };
        },
        methods: {
            getClasses() {
                let classes = ['icon'];
    
                if(this.name) {
                    classes.push(`icon--${this.name}`);
                }
    
                if(this.color) {
                    classes.push(`icon--color-${this.color}`);
                }
                return classes.join(' ');
            }
        }
    };
</script>